import { createReducer, on, Action } from '@ngrx/store';
import * as TypeAHeadActions from './type-ahead.actions';
import { ServiceError, DrugList } from '../formulary/formulary.models';

export const TYPEAHEAD_FEATURE_KEY = 'typeAHead';

export interface TypeaHeadState {
  loaded: boolean;
  typeaHead?: DrugList[];
  error?: ServiceError | boolean;
}

export interface TypeAHeadPartialState {
  readonly [TYPEAHEAD_FEATURE_KEY]: TypeaHeadState;
}

export const typeaHeadInitialState: TypeaHeadState = {
  loaded: false,
};

const typeAHeadReducer = createReducer(
  typeaHeadInitialState,
  on(TypeAHeadActions.loadTypeAHead, (state) => ({
    ...state,
    typeaHead: [],
    loaded: false,
    error: undefined,
  })),
  on(TypeAHeadActions.loadTypeAHeadSuccess, (state, { formulary }) => ({
    ...state,
    data: undefined,
    typeaHead: formulary.formularyDrugList.drugList,
    loaded: true,
  })),

  on(TypeAHeadActions.loadTypeAHeadFailure, (state) => ({
    ...state,
    error: false,
    loaded: true,
  })),
);

export function thReducer(state: TypeaHeadState | undefined, action: Action) {
  return typeAHeadReducer(state, action);
}
